// extracted by mini-css-extract-plugin
export var summerWinterHeroTitle = "programs-module--summer-winter-hero-title--3n0ob";
export var aboutEblHeroTitle = "programs-module--about-ebl-hero-title--1Urvo";
export var classRichtext = "programs-module--class-richtext--wh-DR";
export var summerWinterRichtext = "programs-module--summer-winter-richtext--1SyqQ";
export var libraryHeroTitle = "programs-module--library-hero-title--2Md5c";